function _isIterable(a) {
    return typeof (a === null || a === void 0 ? void 0 : a[Symbol.iterator]) === "function";
}
export default _isIterable;
